<template>
  <div>Список пуст</div>
</template>

<script>
export default {
  name: "EmptyListMessage",
};
</script>